import React from 'react';
import Client from '../../assets/images/Services/Client.png';
import Foreign from '../../assets/images/Services/Foreign.png';
import Prispek from '../../assets/images/Services/Prispek.png';
import Wealth from '../../assets/images/Services/Wealth.png';

import { Link } from 'react-router-dom';
import { Button, Stack } from '@mui/material';
import { useEvents } from '../../context';
import { PrispekServices, PrismaServices, SpektraServices } from '../../constants';
import { ServicesClientLogin, ServicesCompany } from '..';
import ServicesCard from "../services/Services.Card";

export const ServicesSection: React.FC<
    React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>
> = React.memo(props => {
    const { contactValueHandler } = useEvents();
    return (
        <>
            <section className='landing__services' {...props}>
                <div className='landing__services__service'>
                    <ServicesCompany
                        company='Prispek'
                        services={PrispekServices}
                    />
                </div>
                <div className='landing__services__service'>
                    <ServicesCompany
                        company='Spektra'
                        services={SpektraServices}
                    />
                </div>
                <div className='landing__services__service'>
                    <ServicesCompany
                        company='Prisma'
                        services={PrismaServices}
                    />
                </div>
            </section>
            <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-evenly" spacing={1} my={4}>
            <ServicesCard
                    // style={{ backgroundColor: "#0B1E2D" }}
                    title="Prispek Community"
                    icon={Prispek}
                    alt="Prispek Community"
                    cta="Search"
                    href="https://prispekcommunity.co.za/"
                />
                <ServicesCard
                    // style={{ backgroundColor: "#740000" }}
                    title="Client Profile"
                    icon={Client}
                    alt="Client Profile"
                    cta="Login"
                    href="https://spektra.wealthportal.co.za"
                />
                <ServicesCard
                    // style={{ backgroundColor: "#0B1E2D" }}
                    title="Foreign Currency Transaction"
                    icon={Foreign}
                    alt="Foreign Currency Transaction"
                    cta="Transact"
                    href="https://currencypartners.co.za/partner/prispek-personal/"
                />
                {/* <ServicesCard
                    style={{ backgroundColor: "#740000" }}
                    title="Wealth Planning Tool"
                    icon={Wealth}
                    alt="Wealth Planning Tool"
                    cta="Plan Now"
                    href="https://planner.wealthbit.co/spektra/auth/login"
                /> */}
            </Stack>
            <div className='landing__services__buttons'>
                <Button
                    component={Link}
                    to='/services'
                    variant='contained'
                    color="secondary"
                    className='landing__services__buttons__button'
                >
                    About Us
                </Button>
                <Button
                    component={Link}
                    to='/contact'
                    variant='contained'
                    color='primary'
                    className='landing__services__buttons__button'
                >
                    Book Appointment
                </Button>
                <Button
                    component={Link}
                    to='/contact'
                    variant='contained'
                    className='landing__services__buttons__button'
                    onClick={() => {
                        contactValueHandler(1);
                    }}
                >
                    Contact Us
                </Button>
            </div>
        </>
    );
});
